import React from 'react';
import PropTypes from 'prop-types';
import Rating from './Rating';

const RatingScale = props => {
  const {
    ratingOptions = [],
    setScore = () => {},
    score,
    hoverCount = null,
    setHoverCount = () => {},
    disabled = false,
    customClassName,
  } = props;

  return (
    <div className={customClassName}>
      {ratingOptions.map((rating, index) => (
        <Rating
          rating={rating}
          key={rating.score}
          position={index + 1}
          setHoverCount={setHoverCount}
          hoverCount={hoverCount}
          score={score}
          setScore={setScore}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

RatingScale.propTypes = {
  ratingOptions: PropTypes.arrayOf(
    PropTypes.shape({ description: PropTypes.string, score: PropTypes.number }),
  ),
  setScore: PropTypes.func,
  score: PropTypes.number,
};

export default RatingScale;
